module.exports = __webpack_public_path__ + "static/media/what-is-pkt-bg.9045730f.svg";